export function parseQuery(query) {
    var specialValues = {
        'null': null,
        'true': true,
        'false': false
    };
    if (!query) return {};
    if (typeof query !== "string")
        return query;
    
    var queryLength = query.length;
    if (query.substr(0, 1) === "{" && query.substr(-1) === "}") {
        return JSON.parse(query);
    }

    var queryArgs = query.split(/[,\&]/g);

    var result = {};

    queryArgs.forEach(function (arg) {
        var idx = arg.indexOf("=");
        if (idx >= 0) {
            var name = arg.substr(0, idx);
            var value = decodeURIComponent(arg.substr(idx + 1));
            if (specialValues.hasOwnProperty(value)) {
                value = specialValues[value];
            }
            if (name.substr(-2) === "[]") {
                name = decodeURIComponent(name.substr(0, name.length - 2));
                if (!Array.isArray(result[name]))
                    result[name] = [];
                result[name].push(value);
            } else {
                name = decodeURIComponent(name);
                result[name] = value;
            }
        } else {
            if (arg.substr(0, 1) === "-") {
                result[decodeURIComponent(arg.substr(1))] = false;
            } else if (arg.substr(0, 1) === "+") {
                result[decodeURIComponent(arg.substr(1))] = true;
            } else {
                result[decodeURIComponent(arg)] = true;
            }
        }
    });
    return result;
};

export function parseString(str) {
    try {
        if (str[0] === '"') return JSON.parse(str);
        if (str[0] === "'" && str.substr(str.length - 1) === "'") {
            return parseString(str.replace(/\\.|"/g, function (x) {
                if (x === '"') return '\\"';
                return x;
            }).replace(/^'|'$/g, '"'));
        }
        return JSON.parse('"' + str + '"');
    } catch (e) {
        return str;
    }
};

function normalizeMap (map) {
    return Array.isArray(map) 
    ? map.map(key => ({ key, val: key })) 
    : Object.keys(map).map(key => ({key, val: map[key]}))
}

export  function mapDirective (directive) {
    var normalized = normalizeMap(directive)[0]

    return [normalized.key, () => normalized.val ];
}




// WEBPACK FOOTER //
// ./src/core/util.js